// extracted by mini-css-extract-plugin
export default {"loginWrapper":"Login_loginWrapper__sJhtN","loginContainer":"Login_loginContainer__eI44s","input":"Login_input__8bPu8","button":"Login_button__KWidf"};